import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmarCajaComponent } from '../confirmar-caja/confirmar-caja.component';
import { Inject } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-lista-formas-pago',
  templateUrl: './lista-formas-pago.component.html',
  styleUrls: ['./lista-formas-pago.component.css']
})
export class ListaFormasPagoComponent {
  total: number = 0;
  @Output() formasPagoChange = new EventEmitter<any[]>();

  formasPago: any[] = [];
  sumaPagos: number = 0;
  dataSource: MatTableDataSource<any>;

  constructor(
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<ListaFormasPagoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.total = data.total;
    this.dataSource = new MatTableDataSource(this.formasPago);
  }

  agregarFormaPago() {
    const dialogRef = this.dialog.open(ConfirmarCajaComponent, {
      width: '500px',
      data: { total: this.calcularMontoPendiente() }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.formasPago.push(result);
        this.dataSource.data = this.formasPago;
        this.sumaPagos = this.sumarPagos();
        this.formasPagoChange.emit(this.formasPago);
      }
    });
  }

  calcularMontoPendiente() {
    // sumar los valores de la tabla
    const sumaPagos = this.sumarPagos();
    // restar la suma de los pagos al total
    const montoPendiente = this.total - sumaPagos;
    return montoPendiente > 0 ? montoPendiente : 0;
  }

  eliminarFormaPago(idx: number) {
    this.formasPago.splice(idx, 1);
    this.dataSource.data = this.formasPago;
    this.sumaPagos = this.sumarPagos();
    this.formasPagoChange.emit(this.formasPago);
  }

  confirmarPagos() {
    if (this.formasPago.length > 0 && this.sumaPagos >= this.total) {
      console.log('Pagos confirmados:', this.formasPago);
      this.dialogRef.close(this.formasPago);
    }
  }

  cancelar() {
    // Si el componente se usa como diálogo, cerrar el diálogo
    if (this.dialogRef) {
      this.dialogRef.close(null);
    }
  }

  sumarPagos() {
    return this.formasPago.reduce((acc, p) => acc + Number(p.montorecibido), 0);
  }
}
